import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ManageBooking from "@/pages/ManageBooking";
import SignContract from "@/pages/SignContract";
import LeaveReview from "@/pages/LeaveReview";

function App() {
  return (
    <>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/manage/:id" element={<ManageBooking />} />
          <Route path="/contract/:id" element={<SignContract />} />
          <Route path="/review/:id" element={<LeaveReview />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
